import styled, { css } from 'styled-components'

import { AddDollarSign } from '@/app/types'
import { EmbraceHeartLoaderProps } from '.'

export const EmbraceHeartContainer = styled.div<AddDollarSign<EmbraceHeartLoaderProps>>`
  box-sizing: border-box;

  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection};
  align-items: center;
  justify-content: center;
  gap: 5px;

  min-height: 0;
  min-width: 0;
  max-height: 100%;
  max-width: 100%;
  height: ${({ $size }) => `${$size}px`};
  width: ${({ $size, $flexDirection }) => ($flexDirection === 'row' ? 'fit-content' : `min(${$size}px, 100%)`)};

  .loading-dots {
    width: ${({ $flexDirection }) => ($flexDirection === 'row' ? 'auto' : '100%')};
  }

  ${({ $isFullPage }) =>
    $isFullPage &&
    css`
      height: 100%;
      width: 100%;

      .loading-dots {
        width: auto;
      }
    `}

  background-color: ${({ $isFullPage }) => ($isFullPage ? 'var(--gray-0)' : 'transparent')};
`
